const Loader = () => {
  return (
    <div className=" w-[100vw] h-[100vh] flex items-center justify-center bg-gradient-to-r from-black to-slate-900">
      <div class="loader"></div>
    </div>
  );
};
export default Loader;
